import { isWeb } from "@memorang/helpers/platform";
import type { PteWorkflowUserResponse } from "../types/pte-assessor";

const AUDIO_MIME_TYPE = isWeb ? "audio/webm" : "audio/mp4";
const AUDIO_EXTENSION = isWeb ? "webm" : "m4a";

export const buildAudioFileName = (
	userId: string,
	sessionId: number,
	itemId: number,
): string => `${userId}-${sessionId}-${itemId}.${AUDIO_EXTENSION}`;

export const toAudioResponse = (source: string): PteWorkflowUserResponse => ({
	modality: "audio",
	audio: { source, mimeType: AUDIO_MIME_TYPE },
});

export const toTextResponse = (
	value: unknown,
): PteWorkflowUserResponse | null => {
	const text = typeof value === "string" ? value.trim() : "";
	return text ? { modality: "text", text } : null;
};

export const rawAnswerOf = (userResponse: PteWorkflowUserResponse): string =>
	userResponse.modality === "audio"
		? userResponse.audio.source
		: userResponse.text;
